<template>
    <header class="MContainer">
        <nav>
            <div>
                <router-link to="/"><img class="siteIconMainHeader" src="../assets/images/logo.png" alt=""></router-link>
                <ul :class="burgerMenu">
                    <button @click="burgerMenu = 'close'">
                        &times;
                    </button>
                    <li>
                        <router-link to="/"><span>HOME</span></router-link>
                    </li>
                    <li>
                        <router-link to="/aboutUs"><span>ABOUT US</span></router-link>
                    </li>
                    <li>
                        <router-link to="/services"><span>SERVICES</span></router-link>
                    </li>
                    <li>
                        <router-link to="/portafilo"><span>PORTFOLIO</span></router-link>
                    </li>
                    <li>
                        <router-link to="/contact"><span>CONTACT</span></router-link>
                    </li>
                    <li class="drop-down">
                        <div>RU <img src="../assets/images/dropdown.png" alt=""></div>
                        <ul>
                            <li>RU</li>
                            <li>EN</li>
                            <li>UZ</li>
                        </ul>
                    </li>
                </ul>
                <div class="hamburgerMenuResponsive">
                    <div class="drop-down">
                        <div>RU <img src="../assets/images/dropdown.png" alt=""></div>
                        <ul>
                            <li>RU</li>
                            <li>EN</li>
                            <li>UZ</li>
                        </ul>
                    </div>
                    <div class="gamburgerMenuButton" v-on:click="burgerMenu = 'open'">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </nav>

    </header>
</template>

<script>
    export default {
        name: "ComponentHeader",
        data() {
            return {
                burgerMenu: "close"
            }
        }
    }
</script>

<style scoped lang="scss">
    header {
        nav {
            padding: 5px;

            div {
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                img {
                    height: 50px;
                }
                .siteIconMainHeader {
                    margin: 5px;
                    margin-left: 20.3px;
                }
                .hamburgerMenuResponsive {
                    display: none;
                }

                ul {
                    display: flex;
                    padding-top: 5px;

                    button {
                        display: none;
                    }

                    li {
                        padding: 20px 24px;
                        padding-left: 26.7px;
                        transition: all 1s;

                        .router-link-exact-active {
                            font-family: "helveticaneuecyr";
                            font-size: 15px;
                            color: #49d6cb;
                            font-weight: 700;
                            border-bottom: 2px solid #49d6cb;
                            padding-bottom: 22px;
                        }
                        a {
                            transition: all 0.5s;
                            font-family: "helveticaneuecyr";
                            font-size: 15px;
                            color: #000;
                            border-bottom: 2px solid transparents;
                            padding-bottom: 10px;
                            text-transform: uppercase;
                            span {
                                display: inline-block;

                                &:after {
                                    content: "";
                                    display: block;
                                    margin: 0 auto;
                                    width: 0;
                                    height: 2px;
                                    margin-top: 22px;
                                    background-color: #49d6cb;
                                    -webkit-transition: opacity .3s ease, width .3s ease;
                                    -moz-transition: opacity .3s ease, width .3s ease;
                                    -o-transition: opacity .3s ease, width .3s ease;
                                    transition: opacity .3s ease, width .3s ease;
                                    -ms-transition: opacity .3s ease, width .3s ease;
                                }
                            }


                        }

                    }

                    li:hover {
                        a {
                            color: #49d6cb;

                            span:after {
                                width: 100%;
                            }
                        }
                    }


                    .drop-down {
                        position: relative;

                        div {
                            font-size: 15px;
                            margin-top: 1.3px;
                            img {
                                height: 10px !important;
                                width: 15px !important;
                                margin-top: 4px;
                                margin-right: -21px;
                                margin-left: 5.5px;
                            }
                        }

                        ul {
                            display: none;
                            position: absolute;
                            flex-direction: column;
                            animation: dropdownanimate 1s;
                            background-color: rgba(255, 255, 255, 0.8);
                            right: 12px;
                            li {
                                padding: 5px 10px;
                            }

                            li:hover {
                                cursor: pointer;
                            }
                        }
                    }

                    .drop-down:hover ul {
                        display: flex;
                    }

                }

            }
        }

        .close {
            left: 100% !important;
        }

        .open {
            left: 0% !important;
        }

        .burger_menu_body {
            position: fixed;
            top: 0;
            left: 0%;
            right: 0;
            bottom: 0;
            width: 100vw;
            transition: all 0.5s;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.8);
            z-index: 5000;

            button {
                position: absolute;
                right: 35px;
                margin-top: 18px;
                font-size: 40px;
                color: #fff;
            }

            ul {
                text-align: right;
                margin-top: 60px;

                li {
                    padding: 5px 5px;
                    transition: all 1s;

                    .router-link-exact-active {
                        font-family: "helveticaneuecyr";
                        font-size: 15px;
                        color: #49d6cb;
                        border-bottom: 2px solid #49d6cb;
                        padding-bottom: 10px;
                    }

                    a {
                        transition: all 0.5s;
                        font-family: "helveticaneuecyr";
                        font-size: 15px;
                        color: #000;
                        border-bottom: 2px solid transparent;
                        padding-bottom: 10px;

                        span {
                            display: inline-block;

                            &:after {
                                content: "";
                                display: block;
                                margin: 0 auto;
                                width: 0;
                                height: 2px;
                                margin-top: 10px;
                                background-color: #49d6cb;
                                -webkit-transition: opacity .3s ease, width .3s ease;
                                -moz-transition: opacity .3s ease, width .3s ease;
                                -o-transition: opacity .3s ease, width .3s ease;
                                transition: opacity .3s ease, width .3s ease;
                                -ms-transition: opacity .3s ease, width .3s ease;
                            }
                        }
                    }
                }

                li:hover {
                    a {
                        color: #49d6cb;

                        span:after {
                            width: 100%;
                        }
                    }
                }

            }
        }
    }

    @keyframes dropdownanimate {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }
    @media only screen and (max-width: 1200px) {
        header {
        nav {
            padding: 5px;

            div {
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                img {
                    height: 50px;
                }
                .siteIconMainHeader {
                    margin: 5px;
                    margin-left: 17px;
                }
                .hamburgerMenuResponsive {
                    display: none;
                }

                ul {
                    display: flex;
                    padding-top: 5px;

                    button {
                        display: none;
                    }

                    li {
                        padding: 20px 15px;
                        transition: all 1s;

                        .router-link-exact-active {
                            font-family: "helveticaneuecyr";
                            font-size: 15px;
                            color: #49d6cb;
                            border-bottom: 2px solid #49d6cb;
                            padding-bottom: 22px;
                        }
                        a {
                            transition: all 0.5s;
                            font-family: "helveticaneuecyr";
                            font-size: 15px;
                            color: #000;
                            border-bottom: 2px solid transparents;
                            padding-bottom: 10px;
                            text-transform: uppercase;
                            span {
                                display: inline-block;

                                &:after {
                                    content: "";
                                    display: block;
                                    margin: 0 auto;
                                    width: 0;
                                    height: 2px;
                                    margin-top: 22px;
                                    background-color: #49d6cb;
                                    -webkit-transition: opacity .3s ease, width .3s ease;
                                    -moz-transition: opacity .3s ease, width .3s ease;
                                    -o-transition: opacity .3s ease, width .3s ease;
                                    transition: opacity .3s ease, width .3s ease;
                                    -ms-transition: opacity .3s ease, width .3s ease;
                                }
                            }


                        }

                    }

                    li:hover {
                        a {
                            color: #49d6cb;

                            span:after {
                                width: 100%;
                            }
                        }
                    }


                    .drop-down {
                        position: relative;

                        div {
                            img {
                                height: 10px !important;
                                width: 15px !important;
                                margin-top: 3px;
                                margin-right: -16px;
                                margin-left: 5px;
                            }
                        }

                        ul {
                            display: none;
                            position: absolute;
                            flex-direction: column;
                            left: 18%;
                            animation: dropdownanimate 1s;
                            background-color: rgba(255, 255, 255, 0.8);

                            li {
                                padding: 5px 10px;
                            }

                            li:hover {
                                cursor: pointer;
                            }
                        }
                    }

                    .drop-down:hover ul {
                        display: flex;
                    }

                }

            }
        }

        .close {
            left: 100% !important;
        }

        .open {
            left: 0% !important;
        }

        .burger_menu_body {
            position: fixed;
            top: 0;
            left: 0%;
            right: 0;
            bottom: 0;
            width: 100vw;
            transition: all 0.5s;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.8);
            z-index: 5000;

            button {
                position: absolute;
                right: 35px;
                margin-top: 18px;
                font-size: 40px;
                color: #fff;
            }

            ul {
                text-align: right;
                margin-top: 60px;

                li {
                    padding: 5px 5px;
                    transition: all 1s;

                    .router-link-exact-active {
                        font-family: "helveticaneuecyr";
                        font-size: 15px;
                        color: #49d6cb;
                        border-bottom: 2px solid #49d6cb;
                        padding-bottom: 10px;
                    }

                    a {
                        transition: all 0.5s;
                        font-family: "helveticaneuecyr";
                        font-size: 15px;
                        color: #000;
                        border-bottom: 2px solid transparent;
                        padding-bottom: 10px;

                        span {
                            display: inline-block;

                            &:after {
                                content: "";
                                display: block;
                                margin: 0 auto;
                                width: 0;
                                height: 2px;
                                margin-top: 10px;
                                background-color: #49d6cb;
                                -webkit-transition: opacity .3s ease, width .3s ease;
                                -moz-transition: opacity .3s ease, width .3s ease;
                                -o-transition: opacity .3s ease, width .3s ease;
                                transition: opacity .3s ease, width .3s ease;
                                -ms-transition: opacity .3s ease, width .3s ease;
                            }
                        }
                    }
                }

                li:hover {
                    a {
                        color: #49d6cb;

                        span:after {
                            width: 100%;
                        }
                    }
                }

            }
        }
    }
    }
    @media only screen and (max-width: 860px) {
        header {
        nav {
            padding: 5px;

            div {
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                img {
                    height: 40px;
                }
                .siteIconMainHeader {
                    margin: 5px;
                    margin-left: 17px;
                }
                .hamburgerMenuResponsive {
                    display: none;
                }

                ul {
                    display: flex;
                    padding-top: 5px;

                    button {
                        display: none;
                    }

                    li {
                        padding: 10px 15px;
                        transition: all 1s;

                        .router-link-exact-active {
                            font-family: "helveticaneuecyr";
                            font-size: 10px;
                            color: #49d6cb;
                            border-bottom: 2px solid #49d6cb;
                            padding-bottom: 10px;
                        }
                        a {
                            transition: all 0.5s;
                            font-family: "helveticaneuecyr";
                            font-size: 10px;
                            color: #000;
                            border-bottom: 2px solid transparents;
                            padding-bottom: 0px;
                            text-transform: uppercase;
                            span {
                                display: inline-block;

                                &:after {
                                    content: "";
                                    display: block;
                                    margin: 0 auto;
                                    width: 0;
                                    height: 2px;
                                    margin-top: 10px;
                                    background-color: #49d6cb;
                                    -webkit-transition: opacity .3s ease, width .3s ease;
                                    -moz-transition: opacity .3s ease, width .3s ease;
                                    -o-transition: opacity .3s ease, width .3s ease;
                                    transition: opacity .3s ease, width .3s ease;
                                    -ms-transition: opacity .3s ease, width .3s ease;
                                }
                            }


                        }

                    }

                    li:hover {
                        a {
                            color: #49d6cb;

                            span:after {
                                width: 100%;
                            }
                        }
                    }


                    .drop-down {
                        position: relative;

                        div {
                            font-size: 12px;
                            padding: 3px 0;
                            img {
                                height: 10px !important;
                                width: 15px !important;
                                margin-top: 3px;
                                margin-right: -16px;
                                margin-left: 5px;
                            }
                        }

                        ul {
                            display: none;
                            position: absolute;
                            flex-direction: column;
                            left: 18%;
                            animation: dropdownanimate 1s;
                            background-color: rgba(255, 255, 255, 0.8);

                            li {
                                padding: 5px 10px;
                            }

                            li:hover {
                                cursor: pointer;
                            }
                        }
                    }

                    .drop-down:hover ul {
                        display: flex;
                    }

                }

            }
        }

        .close {
            left: 100% !important;
        }

        .open {
            left: 0% !important;
        }

        .burger_menu_body {
            position: fixed;
            top: 0;
            left: 0%;
            right: 0;
            bottom: 0;
            width: 100vw;
            transition: all 0.5s;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.8);
            z-index: 5000;

            button {
                position: absolute;
                right: 35px;
                margin-top: 18px;
                font-size: 40px;
                color: #fff;
            }

            ul {
                text-align: right;
                margin-top: 60px;

                li {
                    padding: 5px 5px;
                    transition: all 1s;

                    .router-link-exact-active {
                        font-family: "helveticaneuecyr";
                        font-size: 15px;
                        color: #49d6cb;
                        border-bottom: 2px solid #49d6cb;
                        padding-bottom: 10px;
                    }

                    a {
                        transition: all 0.5s;
                        font-family: "helveticaneuecyr";
                        font-size: 15px;
                        color: #000;
                        border-bottom: 2px solid transparent;
                        padding-bottom: 10px;

                        span {
                            display: inline-block;

                            &:after {
                                content: "";
                                display: block;
                                margin: 0 auto;
                                width: 0;
                                height: 2px;
                                margin-top: 10px;
                                background-color: #49d6cb;
                                -webkit-transition: opacity .3s ease, width .3s ease;
                                -moz-transition: opacity .3s ease, width .3s ease;
                                -o-transition: opacity .3s ease, width .3s ease;
                                transition: opacity .3s ease, width .3s ease;
                                -ms-transition: opacity .3s ease, width .3s ease;
                            }
                        }
                    }
                }

                li:hover {
                    a {
                        color: #49d6cb;

                        span:after {
                            width: 100%;
                        }
                    }
                }

            }
        }
    }
    }
    @media only screen and (max-width: 770px) {
        header {
            nav {
                padding: 5px;
                div {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    img {
                        height: 40px;
                    }
                    .hamburgerMenuResponsive {
                        display: flex;
                        padding: 15px 10px;

                        .drop-down {
                            position: relative;

                            div {
                                img {
                                    display: none;
                                    height: 10px !important;
                                    width: 15px !important;
                                    margin-top: 3px;
                                }
                            }

                            ul {
                                display: none;
                                flex-direction: column;
                                position: absolute;
                                animation: dropdownanimate 1s;
                                background-color: #fff;
                                top: 10%;
                                top: 30px;
                                width: 50px!important;
                                height: 100px!important;
                                li {    
                                    margin-top: -0px;
                                    color: #000!important;
                                    z-index: 5;
                                }

                                li:hover {
                                    cursor: pointer;
                                }
                            }
                        }

                    

                        .gamburgerMenuButton {
                            padding: 0px 5px;
                            margin-top: -2px;
                            display: flex;
                            flex-direction: column;
                            width: 30px;
                            height: 20px;

                            span {
                                border-bottom: 2px solid #000;
                                width: 20px;
                                display: flex;
                                flex-direction: column;
                                margin: 2px;
                                padding: 0px;
                                height: 5px;
                            }

                        }

                        .gamburgerMenuButton:hover {
                            cursor: pointer;
                        }
                    }

                    ul {
                        position: fixed;
                        top: -50;
                        left: 0%;
                        right: 0;
                        bottom: 0;
                        width: 100vw;
                        transition: all 0.5s;
                        height: 100vh;
                        background-color: rgba(0, 0, 0, 0.8);
                        z-index: 5000;
                        display: flex;
                        flex-direction: column;
                        button {
                            position: absolute;
                            display: block;
                            right: 25px;
                            top: 5px;
                            font-size: 40px;
                            color: #fff;
                        }

                        text-align: right;
                        padding-top: 60px;
                        padding-right: 20px;
                        .drop-down {
                            display: none;
                        }

                        li {
                            padding: 5px 5px;
                            transition: all 1s;
                            
                            .router-link-exact-active {
                                font-family: "helveticaneuecyr";
                                font-size: 15px;
                                color: #49d6cb;
                                border-bottom: 2px solid #49d6cb;
                                padding-bottom: 10px;
                            }

                            a {
                                transition: all 0.5s;
                                font-family: "helveticaneuecyr";
                                font-size: 15px;
                                color: #fff;
                                border-bottom: 2px solid transparent;
                                padding-bottom: 10px;

                                span {
                                    display: inline-block;

                                    &:after {
                                        content: "";
                                        display: block;
                                        margin: 0 auto;
                                        width: 0;
                                        height: 2px;
                                        margin-top: 10px;
                                        background-color: #49d6cb;
                                        -webkit-transition: opacity .3s ease, width .3s ease;
                                        -moz-transition: opacity .3s ease, width .3s ease;
                                        -o-transition: opacity .3s ease, width .3s ease;
                                        transition: opacity .3s ease, width .3s ease;
                                        -ms-transition: opacity .3s ease, width .3s ease;
                                    }
                                }
                            }
                        }

                        li:hover {
                            a {
                                color: #49d6cb;

                                span:after {
                                    width: 100%;
                                }
                            }
                        }

                    }

                }
            }

            .HamburgerMenu {
                padding: 5px;
                display: flex;
                justify-content: space-between;

                img {
                    height: 40px;
                }

                div {
                    display: flex;
                    padding: 5px 10px;

                    .drop-down {
                        position: relative;

                        div {
                            img {
                                height: 10px !important;
                                width: 15px !important;
                                margin-top: 3px;
                            }
                        }

                        ul {
                            display: none;
                            position: absolute;
                            flex-direction: column;
                            left: 20%;
                            animation: dropdownanimate 1s;
                            margin-top: 35%;

                            li {
                                padding: 5px 10px;
                            }

                            li:hover {
                                cursor: pointer;
                            }
                        }
                    }

                    .drop-down:hover ul {
                        display: flex;
                    }

                    .gamburgerMenuButton {
                        padding: 10px 10px;
                        display: flex;
                        flex-direction: column;
                        width: 30px;
                        height: 20px;

                        span {
                            border-bottom: 2px solid #000;
                            width: 20px;
                            display: flex;
                            flex-direction: column;
                            margin: 2px;
                            padding: 0px;
                            height: 5px;
                        }

                    }

                    .gamburgerMenuButton:hover {
                        cursor: pointer;
                    }
                }


            }

            .close {
                left: 100% !important;
            }

            .open {
                left: 0% !important;
            }

            .burger_menu_body {
                position: fixed;
                top: 0;
                left: 0%;
                right: 0;
                bottom: 0;
                width: 100vw;
                transition: all 0.5s;
                height: 100vh;
                background-color: rgba(0, 0, 0, 0.8);

                button {
                    position: absolute;
                    right: 25px;
                    top: 0%;
                    font-size: 40px;
                    color: #fff;
                }

                ul {
                    text-align: right;
                    margin-top: 50px;

                    li {
                        padding: 10px 30px;

                        a {
                            color: #fff
                        }
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 450px) {
        header {
            nav {
                padding: 5px;
                div {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    img {
                        height: 40px;
                    }
                    .hamburgerMenuResponsive {
                        display: flex;
                        padding: 13px 10px;

                        .drop-down {
                            position: relative;

                            div {
                                img {
                                    display: none;
                                    height: 10px !important;
                                    width: 15px !important;
                                    margin-top: 3px;
                                }
                            }

                            ul {
                                display: none;
                                flex-direction: column;
                                position: absolute;
                                animation: dropdownanimate 1s;
                                background-color: #fff;
                                top: 10%;
                                top: 30px;
                                width: 50px!important;
                                height: 100px!important;
                                li {    
                                    margin-top: -0px;
                                    color: #000!important;
                                    z-index: 5;
                                }

                                li:hover {
                                    cursor: pointer;
                                }
                            }
                        }

                    

                        .gamburgerMenuButton {
                            padding: 0px 5px;
                            margin-top: -2px;
                            display: flex;
                            flex-direction: column;
                            width: 30px;
                            height: 20px;

                            span {
                                border-bottom: 2px solid #000;
                                width: 20px;
                                display: flex;
                                flex-direction: column;
                                margin: 2px;
                                padding: 0px;
                                height: 5px;
                            }

                        }

                        .gamburgerMenuButton:hover {
                            cursor: pointer;
                        }
                    }

                    ul {
                        position: fixed;
                        top: -50;
                        left: 0%;
                        right: 0;
                        bottom: 0;
                        width: 100vw;
                        transition: all 0.5s;
                        height: 100vh;
                        background-color: rgba(0, 0, 0, 0.8);
                        z-index: 5000;
                        display: flex;
                        flex-direction: column;
                        button {
                            position: absolute;
                            display: block;
                            right: 25px;
                            top: 5px;
                            font-size: 40px;
                            color: #fff;
                        }

                        text-align: right;
                        padding-top: 60px;
                        padding-right: 20px;
                        .drop-down {
                            display: none;
                        }

                        li {
                            padding: 5px 5px;
                            transition: all 1s;
                            
                            .router-link-exact-active {
                                font-family: "helveticaneuecyr";
                                font-size: 15px;
                                color: #49d6cb;
                                border-bottom: 2px solid #49d6cb;
                                padding-bottom: 10px;
                            }

                            a {
                                transition: all 0.5s;
                                font-family: "helveticaneuecyr";
                                font-size: 15px;
                                color: #fff;
                                border-bottom: 2px solid transparent;
                                padding-bottom: 10px;

                                span {
                                    display: inline-block;

                                    &:after {
                                        content: "";
                                        display: block;
                                        margin: 0 auto;
                                        width: 0;
                                        height: 2px;
                                        margin-top: 10px;
                                        background-color: #49d6cb;
                                        -webkit-transition: opacity .3s ease, width .3s ease;
                                        -moz-transition: opacity .3s ease, width .3s ease;
                                        -o-transition: opacity .3s ease, width .3s ease;
                                        transition: opacity .3s ease, width .3s ease;
                                        -ms-transition: opacity .3s ease, width .3s ease;
                                    }
                                }
                            }
                        }

                        li:hover {
                            a {
                                color: #49d6cb;

                                span:after {
                                    width: 100%;
                                }
                            }
                        }

                    }

                }
            }

            .HamburgerMenu {
                padding: 5px;
                display: flex;
                justify-content: space-between;

                img {
                    height: 40px;
                }

                div {
                    display: flex;
                    padding: 5px 10px;

                    .drop-down {
                        position: relative;

                        div {
                            img {
                                height: 10px !important;
                                width: 15px !important;
                                margin-top: 3px;
                            }
                        }

                        ul {
                            display: none;
                            position: absolute;
                            flex-direction: column;
                            left: 20%;
                            animation: dropdownanimate 1s;
                            margin-top: 35%;

                            li {
                                padding: 5px 10px;
                            }

                            li:hover {
                                cursor: pointer;
                            }
                        }
                    }

                    .drop-down:hover ul {
                        display: flex;
                    }

                    .gamburgerMenuButton {
                        padding: 10px 10px;
                        display: flex;
                        flex-direction: column;
                        width: 30px;
                        height: 20px;

                        span {
                            border-bottom: 2px solid #000;
                            width: 20px;
                            display: flex;
                            flex-direction: column;
                            margin: 2px;
                            padding: 0px;
                            height: 5px;
                        }

                    }

                    .gamburgerMenuButton:hover {
                        cursor: pointer;
                    }
                }


            }

            .close {
                left: 100% !important;
            }

            .open {
                left: 0% !important;
            }

            .burger_menu_body {
                position: fixed;
                top: 0;
                left: 0%;
                right: 0;
                bottom: 0;
                width: 100vw;
                transition: all 0.5s;
                height: 100vh;
                background-color: rgba(0, 0, 0, 0.8);

                button {
                    position: absolute;
                    right: 25px;
                    top: 0%;
                    font-size: 40px;
                    color: #fff;
                }

                ul {
                    text-align: right;
                    margin-top: 50px;

                    li {
                        padding: 10px 30px;

                        a {
                            color: #fff
                        }
                    }
                }
            }
        }
    }
</style>